import { render, staticRenderFns } from "./SystemStatusForm.vue?vue&type=template&id=48146c40&"
import script from "./SystemStatusForm.vue?vue&type=script&lang=js&"
export * from "./SystemStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports